import React from "react";
import { useSelector } from "react-redux";
import showdown from "showdown";
import classnames from "classnames";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const converter = new showdown.Converter();
  const subtitle = converter.makeHtml(
    currentActivity.websiteData.criteria.subtitle
  );

  return (
    currentActivity &&
    currentActivity.websiteData &&
    currentActivity.websiteData.criteria &&
    currentActivity.websiteData.criteria.data &&
    currentActivity.websiteData.criteria.data.length > 0 && (
      <div
        id="criteria"
        className="gradiant-background pwg-section features-section section"
      >
        <div className="container tab-fix">
          <div className="section-head heading-light text-center">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 mb-4">
                <h2 className="heading heading-light whitetxt">
                  {currentActivity.websiteData.criteria.title
                    ? currentActivity.websiteData.criteria.title
                    : "Criteria"}
                </h2>
                {currentActivity.websiteData.criteria.subtitle && (
                  <p
                    className="h4 heading-light"
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="features-content justify-content-around pt-10 pb-10 mb-4">
            <div className="row text-center">
              {currentActivity.websiteData.criteria.data.map((cr, i) => {
                const title = converter.makeHtml(cr.title);
                const description = converter.makeHtml(cr.description);
                return (
                  <div
                    key={i}
                    className={classnames(
                      {
                        "col-md-6 col-sm-12 mb-6":
                          currentActivity.websiteData.criteria.data.length %
                            2 ===
                          0,
                      },
                      {
                        "col-md-4 col-sm-12 mb-6":
                          currentActivity.websiteData.criteria.data.length %
                            2 !==
                          0,
                      }
                    )}
                  >
                    <div className="ld-flipbox">
                      <div className="box ld-flipbox-wrap">
                        <div
                          className="ld-flipbox-face ld-flipbox-front backgroundwhite"
                          style={{
                            borderRadius: "8px",
                          }}
                        >
                          <span className="ld-flipbox-overlay ld-overlay bg-fade-dark-045" />

                          <div className="ld-flipbox-inner">
                            <img
                              src={cr.icon}
                              alt="software"
                              style={{ width: 120 }}
                            />
                          </div>
                        </div>

                        <div className="ld-flipbox-face ld-flipbox-back backgroundwhite">
                          <span className="ld-flipbox-overlay ld-overlay" />

                          <div className="ld-flipbox-inner">
                            <p>
                              <span
                                className="btn-txt black"
                                dangerouslySetInnerHTML={{
                                  __html: description,
                                }}
                              ></span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h4
                      style={{
                        color: "white",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: title,
                      }}
                    ></h4>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    )
  );
};
